import { Link } from "@merge-api/merge-javascript-shared";
import useAgentHandlerLinkModalContext from "../context/useAgentHandlerLinkModalContext";

export const TOS_FOOTER_URL = "https://www.merge.dev/legal/end-user-terms";

const TOSFooter = () => {
  // hooks
  const { isLinkTAndCHidden } = useAgentHandlerLinkModalContext();

  // If isLinkTAndCHidden is true, don't render the component
  if (isLinkTAndCHidden) {
    return null;
  }

  return (
    <div className="flex justify-center items-center py-3">
      <span className="text-gray-60 text-11 font-normal	leading-4">
        {"This integration is powered by Merge. Find out more"}{" "}
        <Link className="underline text-black" href={TOS_FOOTER_URL}>
          {"here"}
        </Link>
      </span>
    </div>
  );
};

export default TOSFooter;
